<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>깜짝퀴즈관리</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          컨텐츠관리
        </li>
        <li class="breadcrumb-item active">
          <a href="/cs/kjquiz">깜짝퀴즈 관리</a>
        </li>
      </ol>
    </div>
    <!-- 검색 -->
    <div class="card card-default" v-show="data.params.mode=='list'" >
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <sch-date-range label="등록일" :data="data"/>
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" @reset="reset"/>
        </div>
      </div>
    </div>
    <!-- // 검색-->

    <!-- 목록 -->
    <div v-show="data.params.mode=='list'" class="card card-default">
      <div class="page-search mt-3 ml-3">
        <div class="float-left">
          <span class="d-inline-block">결과 내 검색</span>
          <input type="text" class="d-inline-block form-control ml-2" v-model="page.filterWord" @keyup.enter="searchFilter()" style="width: 200px"/>
        </div>
        <div class="float-right mr-3 mt-1">
          <b-button @click="popupAddOpen()" class="btn btn-xs btn-outline-info mr-5" variant="outline-primary">카테고리관리</b-button>
          <input type="checkbox" class="mt-1" v-model="page.noMapping" @change="search(1)"><span class="d-inline-block ml-1">카테고리 매핑정보 없는 깜짝퀴즈만 보기</span>
        </div>
      </div>
      <div class="card-header mt-2">
       <div class="d-inline h3">목록</div>
        <!-- <div class="card-tool float-right">
          <b-button @click="popupAdd = true;" class="btn btn-xs btn-outline-info mr-2" variant="outline-primary">
            New
          </b-button>
        </div> -->
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td class="text-center">콘텐츠 ID</td>
              <td class="text-center" @click="localSort.sort('contTitle')">제목<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td class="text-center">카테고리매핑</td>
              <td class="text-center">교과서매핑</td>
              <td class="text-center">키워드</td>
              <td class="text-center">학년정보</td>
              <td class="text-center" @click="localSort.sort('updDt')">수정일<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td class="text-center">등록자</td>
              <td class="text-center" width="80">설정</td>
            </tr>
          </thead>
          <tbody>
          <tr v-show="data.count==0" class="text-center">
            <td colspan="7">No matching records</td>
          </tr>
          <tr v-show="data.count>0" v-for="(item, index) in data.list" :key="index">
            <td class="text-center">{{ item.contSeq }}</td>
            <td>{{ item.contTitle }}</td>
            <td>{{ getCategoryStr(item.categoryCds) }}</td>
            <td>{{ getBookMappingInfo(item.mappingInfo) }}</td>
            <td>{{ item.keywords.replace(/;/g,' ') }}</td>
            <td>{{ getGrdChkYnsStr(item.grdChkYns) }}</td>
            <td class="text-center">
              <div>{{item.updDt}}</div>
            </td>
            <td class="text-center">
              <div>{{item.userId}}</div>
            </td>
            <td class="text-center">
              <div>
                <b-btn variant="outline-info mr-2" class="btn btn-sm btn-secondary" @click.prevent="popupOpen(item);"><em class="fa fa-search"></em></b-btn>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)"
                      @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->
    <b-modal id="kjquizModal" size="xl" title="깜짝퀴즈관리" v-model="page.popupInfo.show" hide-footer>
      <CsKjquizPageInfo :contSeq="page.popupInfo.contSeq" @get-data="search()" @modal-state="popupClose"/>
    </b-modal>
    <b-modal id="kjquizCategoryRegModal" size="xl" title="카테고리등록" v-model="page.popupAdd.show" hide-footer>
      <CsKjquizCategorySetting @get-data="search(1)" @modal-state="popupClose" />
    </b-modal>
  </ContentWrapper>
</template>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {getCsCodeList} from "@/api/cs/CsCodeApi";
import {getCsKjquizList, saveCsKjquiz} from "@/api/cs/CsKjquizApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject,purpTypeCd, getFileTypeName, getFileDivName} from "@/utils/Constants";
import CsKjquizPageInfo from "../cs/CsKjquizPageInfo"
import CsKjquizCategorySetting from "../cs/CsKjquizCategorySetting"
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";

export default {
  components: {SchDateRange, SchText, Pagenation, CsKjquizPageInfo, CsKjquizCategorySetting},
  setup(props, {root}) {
    const _dataObject = _.cloneDeep(dataObject); //cloneDeep 객체복사 
    const data = reactive(_dataObject) //reactive 반응형 
    let kjquizCodeList = [];

    const schOptions = [{value: 'contTitle', text: '제목'}, {value: 'contSeq', text: '콘텐츠 ID'}, {value: 'cate', text: '카테고리 코드'}]
    data.schOptions = schOptions // 검색 type 선택 

    const page = reactive({
      popupInfo: {
        show:false,
        contSeq:0
      },
      popupAdd: {
        show:false,
        contSeq:0,
      },
      noMapping:false,
      filterWord:'',
      orgDataList:[],
    })

    const loadCategory = async () => {
      const result = await getCsCodeList({pCode: 'KJ_QUIZ_CATEGORY_CD', ignoreRegId: true, sort: 'code', direction: 'asc'});
      kjquizCodeList = result.data;
      console.log('kjquiz code list', kjquizCodeList); // test
    }

    const search = async (pageNo) => {
      if (pageNo && !isNaN(pageNo)) {
        data.params.page = pageNo;
      }
      data.params.noMapping = !!page.noMapping;
      const result = await getCsKjquizList(data.params);
      console.log('first item', result.data[0]); // test
      data.list = result.data;
      data.count = result.count;
      page.orgDataList = _.cloneDeep(data.list);
      root.$_localSort.set(data.list);
    }

    // 결과내 검색
    const searchFilter = async () => {
      //console.log(`searchFilter called:'${page.filterWord}'`);
      const filterWord = page.filterWord.trim();
      const filteredList = page.orgDataList.filter((item) => {
        const index = item.contTitle.indexOf(filterWord);
        //console.log('item.contTitle, index', item.contTitle, index);
        return index != -1;
      });
      data.list = filteredList;
      root.$_localSort.set(data.list);
    }

    const reset = async () => {
      data.params.schType = '';
      data.params.schText = '';
      search(1);
    }

    const getGrdChkYnsStr = (grdChkYns) => {
      let grd = ['초1', '초2', '초3', '초4', '초5', '초6', '중1', '중2', '중3', '고1', '고2', '고3'];
      let str = '';
      for(let i = 0; i < 12; i++) {
        if((grdChkYns>>i)&1) {
          if (str.length > 0) str += '/';
          str += grd[i];
        }
      }
      return str;
    }

    const getCategoryStr = (categoryCds) => {
      let str = [];
      categoryCds.split(',').forEach(cd => {
        let el = kjquizCodeList.find(e => e.code == cd );
        if (el) str.push(el.codeNm);
      });
      return str.join(' / ');
    }

    const getBookMappingInfo = (mappingInfo) => {
      if (mappingInfo && mappingInfo.includes(';')) {
        return mappingInfo.split(';')[0]+'...'
      }
      return mappingInfo;
    }

    const popupOpen = (item) => {
      console.log('select item', item); // test
      page.popupInfo.contSeq = item.contSeq;
      page.popupInfo.show = true;
    }

    const popupAddOpen = () => {
      page.popupAdd.show = true;
    }

    const popupClose = (item, isModified) =>{
      if(item == 'info'){
        page.popupInfo.show=false;
      }else{
        page.popupAdd.show = false;
      }
      if (isModified) {
        search(1);
      }
    }

    const retVals = {
      purpTypeCd,
      getFileTypeName,
      getFileDivName,
      page,
      data,
      loadCategory,
      search,
      searchFilter,
      reset,
      getGrdChkYnsStr,
      getCategoryStr,
      getBookMappingInfo,
      popupOpen,
      popupAddOpen,
      popupClose,
      dataAction: new TableActionClass(data),
      localSort:root.$_localSort
    }

    onMounted(async () => {
      retVals.loadCategory();
      retVals.search();
    })

    return retVals;
  },
}

</script>